import { IFullPlanDetail, IFullPlanDetailPPO } from "../../interfaces/api";
import CompareStick from "./CompareStick.component";
import AccessDemand from "./AccessDemand.component";

const AllPlansHeader = ({
  plans,
}: {
  plans: IFullPlanDetail[] | IFullPlanDetailPPO[];
}) => {
  const storageData = sessionStorage.getItem("dataArray");
  const parsedData = storageData ? JSON.parse(storageData) : [];
  const dataArray: string[] = Object.values(parsedData);
  if (dataArray.length < 1) {
    return null;
  }
  while (dataArray.length < 3) {
    dataArray.push("");
  }

  return (
    <div className="grid-x margin-0 hide-for-small-only">
      <h3
        className="cell blue-stroke text-center h3"
        style={{
          fontWeight: 600,
          fontSize: "39px",
          paddingBottom: "47px",
        }}
      >
        Comparing {plans.length} plans
      </h3>
      {plans.length === 3 ? (
        <>
          <div className="cell small-3">
            <AccessDemand />
          </div>
          <div className="cell small-3">
            <CompareStick data={plans[0]} />
          </div>
          <div className="cell small-3">
            <CompareStick data={plans[1]} />
          </div>
          <div className="cell small-3">
            <CompareStick data={plans[2]} />
          </div>
        </>
      ) : (
        <>
          <div className="cell small-4">
            <AccessDemand />
          </div>
          <div className="cell small-4">
            <CompareStick data={plans[0]} />
          </div>
          <div className="cell small-4">
            <CompareStick data={plans[1]} />
          </div>
        </>
      )}
    </div>
  );
};

export default AllPlansHeader;
